import * as React from "react";
import { useToast, TOAST_DEFAULT_DURATION } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

// Radix fecha o toast sozinho após `duration`; o hook já faz o dismiss no
// tempo correto, então o Radix só precisa de um valor que nunca dispare.
// `Infinity` não é aceito (setTimeout vira ~1ms), então limitamos ao máximo.
const RADIX_MAX_DURATION = 2147483647;

const toRadixDuration = (duration?: number) =>
  duration === Infinity
    ? RADIX_MAX_DURATION
    : (duration ?? TOAST_DEFAULT_DURATION);

// Função auxiliar para validar e sanitizar conteúdo
const sanitizeContent = (content: unknown): React.ReactNode => {
  if (typeof content === "string" || typeof content === "number") {
    return content;
  }
  if (React.isValidElement(content)) {
    return content;
  }
  if (content === null || content === undefined) {
    return null;
  }
  if (typeof content === "object") {
    console.warn("Tentativa de renderizar objeto no Toast:", content);
    return JSON.stringify(content);
  }
  return String(content);
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        duration,
        ...props
      }) {
        return (
          <Toast key={id} duration={toRadixDuration(duration)} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{sanitizeContent(title)}</ToastTitle>}
              {description && (
                <ToastDescription>
                  {sanitizeContent(description)}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
